import {combineEpics} from 'redux-observable';
import {usersEpics} from './slices/users';
import {setOffClientMediaInUserStoreEpic, setOnClientMediaInUserStoreEpic} from './slices/roomUsers';

export const rootEpic = combineEpics(
	usersEpics,
	setOffClientMediaInUserStoreEpic,
	setOnClientMediaInUserStoreEpic
);
